<script lang="ts">
  import { get } from 'svelte/store'
  import { useKeyboardListener } from '../../hooks'
  import { cameraControls, focusOnObject } from '../../stores/camera'
  import { canvasSelection } from '../../stores/canvas-selection'

  function focusSelected() {
    const selection = get(canvasSelection)
    if (selection) {
      focusOnObject(selection)
    }
    else {
      get(cameraControls)?.setLookAt(0, -15, 30, 0, 0, 0, true)
    }
  }

  $effect(() => {
    return useKeyboardListener(';', { onKeyPress: focusSelected })
  })
</script>
